var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconDeleteComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-delete ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 6.62581C7.26743 6.62581 7.41667 6.77505 7.41667 6.95915V10.9591C7.41667 11.1432 7.26743 11.2925 7.08333 11.2925H6.58333C6.39924 11.2925 6.25 11.1432 6.25 10.9591V6.95915C6.25 6.77505 6.39924 6.62581 6.58333 6.62581H7.08333zM9.41667 11.2925C9.60076 11.2925 9.75 11.1432 9.75 10.9591V6.95915C9.75 6.77505 9.60076 6.62581 9.41667 6.62581H8.91667C8.73257 6.62581 8.58333 6.77505 8.58333 6.95915V10.9591C8.58333 11.1432 8.73257 11.2925 8.91667 11.2925H9.41667z",
    fillOpacity: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 2.62581C5.41667 1.75136 6.12555 1.04248 7 1.04248H9C9.87445 1.04248 10.5833 1.75136 10.5833 2.62581V3.29248H13.6667C13.8508 3.29248 14 3.44172 14 3.62581V4.29248C14 4.47658 13.8508 4.62581 13.6667 4.62581H12.9776L12.4171 12.3854C12.3935 12.7133 12.373 12.9973 12.3374 13.2311C12.2997 13.4787 12.2383 13.723 12.1044 13.9559C11.9038 14.305 11.6024 14.5854 11.2397 14.7604C10.9979 14.8771 10.7498 14.9207 10.5 14.9405C10.2643 14.9592 9.97955 14.9592 9.65082 14.9592H6.34901C6.02029 14.9592 5.73548 14.9592 5.49975 14.9405C5.25003 14.9207 5.00194 14.8771 4.76007 14.7604C4.39741 14.5854 4.09603 14.305 3.89535 13.9559C3.76151 13.723 3.70013 13.4787 3.66242 13.2311C3.62682 12.9973 3.60631 12.7133 3.58264 12.3854L3.02223 4.62581H2.33333C2.14924 4.62581 2 4.47658 2 4.29248V3.62581C2 3.44172 2.14924 3.29248 2.33333 3.29248H5.41667V2.62581ZM4.35904 4.62581L4.91074 12.2648C4.9367 12.6242 4.95386 12.855 4.98056 13.0304C5.00602 13.1976 5.03321 13.2599 5.05131 13.2914C5.11821 13.4078 5.21867 13.5012 5.33955 13.5596C5.37227 13.5754 5.43635 13.598 5.605 13.6113C5.78179 13.6253 6.01328 13.6258 6.3736 13.6258H9.62619C9.98651 13.6258 10.218 13.6253 10.3948 13.6113C10.5634 13.598 10.6275 13.5754 10.6602 13.5596C10.7811 13.5012 10.8816 13.4078 10.9485 13.2914C10.9666 13.2599 10.9938 13.1976 11.0192 13.0304C11.0459 12.855 11.0631 12.6242 11.089 12.2648L11.6408 4.62581H4.35904ZM9.41667 2.62581C9.41667 2.3957 9.23012 2.20915 9 2.20915H7C6.76988 2.20915 6.58333 2.3957 6.58333 2.62581V3.29248H9.41667V2.62581Z",
    fillOpacity: "1"
  }));
}
var IconDelete = /*#__PURE__*/React.forwardRef(IconDeleteComponent);
export default IconDelete;